import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {useNotification} from '~/hooks';
import {RootState} from '~/redux/root-reducer';
import NotFoundPage from '~/pages/not-found';
import {BIRTH_CONTROL_REFILL_KEYS} from '~/constants/medical-questionnaires';
import Questionnaire1Screen from '~/pages/homes/birth-control-refill/Questionnaire1Screen';
import Questionnaire2Screen from '~/pages/homes/birth-control-refill/Questionnaire2Screen';
import Questionnaire3Screen from '~/pages/homes/birth-control-refill/Questionnaire3Screen';
import Questionnaire4Screen from '~/pages/homes/birth-control-refill/Questionnaire4Screen';
import Questionnaire5Screen from '~/pages/homes/birth-control-refill/Questionnaire5Screen';
import Questionnaire6Screen from '~/pages/homes/birth-control-refill/Questionnaire6Screen';
import Questionnaire7Screen from '~/pages/homes/birth-control-refill/Questionnaire7Screen';
import Questionnaire8Screen from '~/pages/homes/birth-control-refill/Questionnaire8Screen';
import Questionnaire9Screen from '~/pages/homes/birth-control-refill/Questionnaire9Screen';
import Questionnaire10Screen from '~/pages/homes/birth-control-refill/Questionnaire10Screen';
import Questionnaire11Screen from '~/pages/homes/birth-control-refill/Questionnaire11Screen';
import Questionnaire12Screen from '~/pages/homes/birth-control-refill/Questionnaire12Screen';
import {redirectInIframe} from '~/utils/helpers';
import {trackPageViewGA} from '~/services/google-analytics';
// import Questionnaire13Screen from '~/pages/homes/birth-control-refill/Questionnaire13Screen';

const BirthControlRefill = () => {
  const dispatch: AppDispatch = useDispatch();
  const {addMessage} = useNotification(dispatch);

  const activeQuestion = useSelector((state: RootState) => state.questionnaires.activeQuestion);
  const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  const {wpAuthUser} = medicalQuestionnaire;
  const questionnaires = medicalQuestionnaire?.questionnaires;

  useEffect(() => {
    if (!wpAuthUser?.id) {
      if (wpAuthUser?.baseURL && wpAuthUser?.currentURL) {
        redirectInIframe(wpAuthUser.baseURL + '/login/?redirect_to=' + wpAuthUser?.currentURL, '_self');
      }
    }
  }, [wpAuthUser?.baseURL, wpAuthUser?.currentURL, wpAuthUser?.id]);

  if (!questionnaires?.length) return null;
  if (!wpAuthUser?.id) return null;

  const renderQuestion = () => {
    const keys = activeQuestion.keys;
    const key = keys[keys.length - 1];
    switch (key) {
      case BIRTH_CONTROL_REFILL_KEYS.START:
        trackPageViewGA('/bc-refill/start', 'MDQ-BC Refill - Start');
        return <Questionnaire1Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.PROFILE:
        trackPageViewGA('/bc-refill/profile', 'MDQ-BC Refill - Profile');
        return <Questionnaire2Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.INVALID:
        trackPageViewGA('/bc-refill/invalid', 'MDQ-BC Refill - Invalid');
        return <Questionnaire3Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.LAST_BC_PURCHASE:
        trackPageViewGA('/bc-refill/last-bc-purchase', 'MDQ-BC Refill - Last BC Purchase');
        return <Questionnaire4Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.STATEMENT_BEST_APPLIES:
        trackPageViewGA('/bc-refill/statement-best-applies', 'MDQ-BC Refill - Statement Best Applies');
        return <Questionnaire5Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.MEDICAL_HISTORY:
        trackPageViewGA('/bc-refill/medical-history', 'MDQ-BC Refill - Medical History');
        return <Questionnaire6Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.HAD_BLOOD_PRESSURE_MEASURED_LAST_6_MONTH:
        trackPageViewGA(
          '/bc-refill/had-blood-pressure-measured-last-6-month',
          'MDQ-BC Refill - Had Blood Pressure Measured Last 6 Month',
        );
        return <Questionnaire7Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.DO_SMOKE:
        trackPageViewGA('/bc-refill/do-smoke', 'MDQ-BC Refill - Do Smoke');
        return <Questionnaire8Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.HAS_SMOKED:
        trackPageViewGA('/bc-refill/has-smoked', 'MDQ-BC Refill - Has Smoked');
        return <Questionnaire9Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.OTHER_MEDICAL_HISTORY:
        trackPageViewGA('/bc-refill/other-medical-history', 'MDQ-BC Refill - Other Medical History');
        return <Questionnaire10Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.CHOOSE_MEDICATION:
        trackPageViewGA('/bc-refill/choose-medication', 'MDQ-BC Refill - Choose Medication');
        return <Questionnaire11Screen />;
      case BIRTH_CONTROL_REFILL_KEYS.CHOOSE_PRODUCT_PACKAGE:
        trackPageViewGA('/bc-refill/choose-product-package', 'MDQ-BC Refill - Choose Product Package');
        return <Questionnaire12Screen />;
      default:
        // eslint-disable-next-line no-console
        console.warn('Not implement yet!');
        return <NotFoundPage />;
    }
  };

  return renderQuestion();
};

export default BirthControlRefill;
